"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function FolderRevokeIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("polygon", { points: "15.024 9.01 12 12.035 8.976 9.01 7.773 10.212 10.798 13.237 7.773 16.262 8.976 17.464 12 14.439 15.024 17.464 16.227 16.262 13.202 13.237 16.227 10.212 15.024 9.01" }),
        react_1.default.createElement("path", { d: "M20.781,5.208H10.394a.371.371,0,0,1-.261-.108l-1.5-1.5a2.051,2.051,0,0,0-1.462-.607H3.219A2.071,2.071,0,0,0,1.15,5.063V18.937a2.071,2.071,0,0,0,2.069,2.069H20.781a2.071,2.071,0,0,0,2.069-2.069V7.276A2.071,2.071,0,0,0,20.781,5.208Zm.369,13.729a.37.37,0,0,1-.369.37H3.219a.37.37,0,0,1-.369-.37V5.063a.37.37,0,0,1,.369-.37H7.171a.371.371,0,0,1,.261.11l1.5,1.5a2.055,2.055,0,0,0,1.462.605H20.781a.37.37,0,0,1,.369.369Z" })));
}
exports.default = FolderRevokeIcon;
